export default __webpack_public_path__ + "static/media/payment-no-record.3add8805.svg";